import React from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';
import { Auth0Provider, getDomain, getClientId, getAudience } from "./auth";
import history from '../common/history';

import Routes from './routes';

// A function that routes the user to the right place after login
const onRedirectCallback = appState => {
    history.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
};

const Root = ({ store }) => {
    return  (
        <Auth0Provider
            domain={getDomain()} 
            client_id={getClientId()}
            audience={getAudience()}
            redirect_uri={window.location.origin} 
            onRedirectCallback={onRedirectCallback}>
            <Provider store={store}>
                <Routes />
            </Provider>
        </Auth0Provider>
    );
};

Root.propTypes = {
    store: PropTypes.object.isRequired
};

export default Root;